import React from 'react';
import pace from '../../vendor/pace/pace';

class Progress extends React.Component {
    render() {
        return (null)
    }

    componentDidMount() {
        pace.start();
    }


}

export default Progress




// WEBPACK FOOTER //
// src/components/common/Progress.js